export default __webpack_public_path__ + "static/media/personal.79ab5e25.jpg";